import { useEffect, useState } from "react";
import { subscribeToJob } from "@hostdock/sdk";
import type { JobRecord } from "@hostdock/types";
import { api } from "../api";

/** Live state of a background job over SSE; null until the first event. */
export function useLiveJob(jobId: string | null | undefined, onEvent?: (job: JobRecord) => void): JobRecord | null {
  const [job, setJob] = useState<JobRecord | null>(null);
  useEffect(() => {
    setJob(null);
    if (!jobId) return;
    return subscribeToJob(api.jobs.eventsUrl(jobId), (e) => {
      setJob(e.job);
      onEvent?.(e.job);
    });
    // onEvent is intentionally not a dependency: callers pass inline callbacks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);
  return job;
}

export const isTerminal = (s: string | undefined) => s === "SUCCESS" || s === "FAILED" || s === "CANCELLED";
